import { render, staticRenderFns } from "./checkout-tiered-message.vue?vue&type=template&id=cb02a030&"
import script from "./checkout-tiered-message.vue?vue&type=script&lang=js&"
export * from "./checkout-tiered-message.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports